module.exports = __webpack_public_path__ + "static/media/actual_size.6b6ec4a7.jpg";